import { Box, Flex } from '@chakra-ui/react';
import moment from 'moment';

import { AlarmClockIcon } from 'Asset/icon';
import { Iteration } from 'Component/others';
import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const LivestreamDatetime = ({ label, startDateTime, endDateTime, violations }) => {
  const startTime = startDateTime ? moment(startDateTime).format('HH:mm') : '-';
  const startDate = startDateTime ? moment(startDateTime).format('DD/MM/YY') : '-';
  const endTime = endDateTime ? moment(endDateTime).format('HH:mm') : '-';
  const endDate = endDateTime ? moment(endDateTime).format('DD/MM/YY') : '-';
  return (
    <Flex className={styles['livestream-datetime__container']}>
      <Flex alignItems="center" gap="8px">
        <TextRegular fontSize="var(--font-caption1)">{label}</TextRegular>
        <Iteration items={violations} render={(violation) => <Box className={styles['livestream-datetime__violation']}>{violation}</Box>} />
      </Flex>
      <Box display="flex" alignItems="center" gap="6px">
        <AlarmClockIcon size={14} color="var(--color-neutral50)" />
        <Box position="relative" width="100%" display="flex">
          <Box width="45%" display="flex" gap="6px">
            <TextMedium className={styles['livestream-datetime__time']}>{startTime}</TextMedium>
            <TextRegular className={`${styles['livestream-datetime__date']} ${startDate === '-' && styles['livestream-datetime__date--empty']}`}>
              {startDate}
            </TextRegular>
          </Box>
          <TextMedium className={styles['livestream-datetime__dash']}>-</TextMedium>
          <Box width="calc(55% + 10px)" display="flex" gap="6px">
            <TextMedium className={styles['livestream-datetime__time']}>{endTime}</TextMedium>
            <TextRegular className={`${styles['livestream-datetime__date']} ${endDate === '-' && styles['livestream-datetime__date--empty']}`}>
              {endDate}
            </TextRegular>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default LivestreamDatetime;
